import axios from 'axios';

export const addShipFrom = async (shipFrom, shouldCreateInventorySource) => {
  const response = await axios.post('/seller/shipfrom', shipFrom, {
    params: {
      shouldCreateInventorySource,
    },
  });
  return response?.data ?? [];
};

export const editShipFrom = async (shipFrom) => {
  const response = await axios.put('/seller/shipfrom', shipFrom);
  return response?.data ?? [];
};

export const getInventorySources = async () => {
  const response = await axios.get('/inventorysources');
  return response?.data ?? [];
};
